import React, { useState } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { MultiSelect } from 'primereact/multiselect';
import RecipeCard from './RecipeCard';

const RecipeSearch = ({ 
    onSearch, 
    recipes, 
    loading, 
    onRecipeClick,
    mealTypes,
    dietTypes,
    intoleranceOptions
}) => {
    const [searchQuery, setSearchQuery] = useState('');
    const [selectedMealType, setSelectedMealType] = useState(null);
    const [selectedDiet, setSelectedDiet] = useState(null);
    const [selectedIntolerances, setSelectedIntolerances] = useState([]);

    const handleSearch = () => {
        onSearch({
            searchQuery,
            selectedMealType,
            selectedDiet,
            selectedIntolerances
        });
    };

    return (
        <div className="search-panel">
            <div className="search-hero">
                <h2>Find Your Perfect Recipe</h2>
                <p>Discover recipes that match your preferences and dietary needs</p>

                <div className="search-box-cooking">
                    <i className="pi pi-search search-iconCooking"></i>
                    <InputText
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        placeholder="Enter ingredients or dish name..."
                        className="main-search"
                        onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
                    />
                </div>
            </div>

            <div className="search-filters">
                <h3>Refine Results</h3>

                <div className="filters-grid">
                    <div className="filter-item">
                        <label htmlFor="mealType">
                            <i className="pi pi-table filter-icon"></i>
                            Meal Type
                        </label>
                        <Dropdown
                            id="mealType"
                            value={selectedMealType}
                            options={mealTypes}
                            onChange={(e) => setSelectedMealType(e.value)}
                            placeholder="Any meal type"
                            className="crf-input-full"
                        />
                    </div>

                    <div className="filter-item">
                        <label htmlFor="diet">
                            <i className="pi pi-heart filter-icon"></i>
                            Diet
                        </label>
                        <Dropdown
                            id="diet"
                            value={selectedDiet}
                            options={dietTypes}
                            onChange={(e) => setSelectedDiet(e.value)}
                            placeholder="Any diet"
                            className="crf-input-full"
                        />
                    </div>

                    <div className="filter-item">
                        <label htmlFor="intolerances">
                            <i className="pi pi-ban filter-icon"></i>
                            Intolerances
                        </label>
                        <Dropdown
                            id="intolerances"
                            value={selectedIntolerances}
                            options={intoleranceOptions}
                            onChange={(e) => setSelectedIntolerances(e.value)}
                            placeholder="Select if any"
                            className="crf-input-full"
                        />
                    </div>
                </div>

                <Button
                    label="Search"
                    icon="pi pi-search"
                    onClick={handleSearch}
                    loading={loading}
                    style={{ gap: '0.5rem' }}
                    className="search-button"
                />
            </div>

            <div className="search-results-container">
                <>
                    <div className="results-header">
                        <h3>We found {recipes.length} recipes for you</h3>
                        <span className="results-tip">Click any recipe to see details</span>
                    </div>
                    <div className="recipes-grid">
                        {recipes.map(recipe => (
                            <div className="recipe-item" key={recipe.id}>
                                <RecipeCard recipe={recipe} onClick={onRecipeClick} />
                            </div>
                        ))}
                    </div>
                </>
            </div>
        </div>
    );
};

export default RecipeSearch; 